import { BonusAnalysisResult } from "@bonusmap/api-types";
import { InputParamGroup, InputParamGroups, isValidInputParamItem } from "./bap-types";

export function parseAnalyzedDataInput(input: any): InputParamGroups | null {
    // deve togliere i valori non conformi
    // deve essere un array di array di oggetti
    const result: InputParamGroups = [];
    if (Array.isArray(input) && input.length > 0) {
        //e un array di array 
        for (const group of input) {
            const groupResult: InputParamGroup = [];
            if (!Array.isArray(group)) {
                return null;
            }
            for (const item of group) {
                if(isValidInputParamItem(item)) {
                    // è un InputParamItem valido lo aggiungo
                    groupResult.push(item);
                }
                else {
                    console.log("parseAnalyzedDataInput: invalid InputParamItem", item);
                }
            }
            if (groupResult.length > 0) {
                result.push(groupResult);
            }
        }
    }
   
    return result.length > 0 ? result : null;
}
export function parseAnalyzedData(analysData:BonusAnalysisResult , key: string = "parameters"): InputParamGroups | null {
    if(analysData && analysData.hasOwnProperty(key)) {
        const data = analysData[key];
        return parseAnalyzedDataInput(data);
    }
    else {
        console.log("parseAnalyzedData: key not found", key, analysData);
    }
    return null;
}